<template>
    <div class="row" :id="item.id + 'LineitemContainer'" style="display: none">
        <div class="col-md-12">
            <div class="p-r-15">
                <div style="border: 1px solid grey; padding: 10px; background: white; margin-bottom: 20px">
                    <div>Type: {{ item.type }}</div>
                    <div>
                        Line item Id :
                        <span>{{ item.xid }}</span>
                    </div>

                    <div>
                        Size :
                        <span v-for="(dimension, index) in item.dimensions" :key="dimension.id">
                            <span v-if="dimensions.length && index + 1 == item.dimensions.length">{{
                                dimensions.filter((k) => k.id == dimension)[0].width +
                                'X' +
                                dimensions.filter((k) => k.id == dimension)[0].height
                            }}</span>
                            <span v-else-if="dimensions.length">{{
                                dimensions.filter((k) => k.id == dimension)[0].width +
                                'X' +
                                dimensions.filter((k) => k.id == dimension)[0].height +
                                ' , '
                            }}</span>
                        </span>
                    </div>
                    <div>
                        Device :
                        <span v-for="(dev, index) in item.device" :key="index">
                            <span v-if="index + 1 == item.device.length">{{
                                devices.length && devices.filter((k) => k.id == dev)[0].name
                            }}</span>
                            <span v-else>{{
                                devices.length && devices.filter((k) => k.id == dev)[0].name + ' , '
                            }}</span>
                        </span>
                    </div>
                    <!-- <div>
             : {{item.placement_text[0]}}
          </div> -->
                    <div v-if="item.type !== 'unitag'">
                        Placements :
                        <ol v-if="item.placement_text && item.placement_text.length" style="margin: 0">
                            <li v-for="(divt, index) in changeItemFormat(item.placement_text[0])" :key="index">
                                <span v-if="divt.data && divt.operator">
                                    <span class="p-l-20"
                                        >{{ index + 1 }}. Operator:
                                        {{ divt.hasOwnProperty('operator') && divt.operator }} , Value:
                                        {{ divt.data ? divt.data : divt }}</span
                                    >
                                </span>
                            </li>
                        </ol>
                    </div>
                    <div>
                        Position :
                        <ol v-if="item.positions && item.positions.length" style="margin: 0">
                            <li v-for="(divt, index) in changeItemFormat(item.positions)" :key="index">
                                <span v-if="divt.data && divt.operator">
                                    <span class="p-l-20"
                                        >{{ index + 1 }}. Operator:
                                        {{ divt.hasOwnProperty('operator') && divt.operator }} , Value:
                                        {{ divt.data ? divt.data : divt }}</span
                                    >
                                </span>
                            </li>
                        </ol>
                    </div>

                    <div>
                        Browser :
                        <span v-for="(browser, index) in item.browsers" v-if="browsers && browsers.length" :key="index">
                            <span v-if="index + 1 == item.browsers.length">{{
                                browsers.filter((k) => k.id == browser)[0].name
                            }}</span>
                            <span v-else>{{ browsers.filter((k) => k.id == browser)[0].name + ' , ' }}</span>
                        </span>
                    </div>
                    <div>
                        Geo :
                        <span v-for="(con, index) in item.country" v-if="countries && countries.length" :key="index">
                            <span v-if="index + 1 == item.country.length">{{
                                countries.filter((k) => k.id == con)[0].code
                            }}</span>
                            <span v-else>{{ countries.filter((k) => k.id == con)[0].code + ' , ' }}</span>
                        </span>
                    </div>

                    <div>
                        Revenue Channels :

                        <ol class="p-l-20" v-for="revenue_channel in item.revenue_channel">
                            <!-- <li v-if="item.revenue_channel.type == 'both' || item.revenue_channel.type == 'rch'">
                                <span> rch: {{ 'intl' + item.revenue_channel.rch }} </span>
                            </li>
                            <li v-if="item.revenue_channel.type == 'both' || item.revenue_channel.type == 'rtb'">
                                <span> rtb: {{ item.revenue_channel.rtb }} </span>
                            </li> -->
                            <li>
                                <span> {{ revenue_channel.type }}: {{ revenue_channel.name }} </span>
                            </li>
                        </ol>
                    </div>
                    <div>
                        Creative :
                        <ol class="p-l-20" v-if="creativeList && creativeList.length">
                            <li v-for="(creative, id) in item.creative" :key="id">
                                {{ id + 1 }}. Name: {{ creativeList.filter((k) => k.id == creative)[0].name }}, Sib Id:
                                {{ creativeList.filter((k) => k.id == creative)[0].sib_id }}
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
// dimensions item, devices, browsers, changeItemFormat, countries, creativeList
export default {
    props: ['dimensions', 'item', 'devices', 'browsers', 'changeItemFormat', 'countries', 'creativeList'],
};
</script>



// WEBPACK FOOTER //
// AdspotDetails.vue?92a2ab3a